<div class="h-full flex flex-col p-6 gap-6" *transloco="let t">
  <!-- Header con pulsante invita artista -->
  <div class="flex justify-between items-center">
    <h2 class="text-2xl font-bold text-gray-800">{{ t('galleryArtists.title') || 'Artisti della Galleria' }}</h2>
    <a 
      [href]="getMailtoLink()"
      wunButton
      primary
      class="inline-block">
      {{ t('galleryArtists.inviteButton') || 'Invita nuovo artista' }}
    </a>
  </div>

  <!-- Filtro per codice galleria -->
  <div class="flex gap-4 items-end">
    <div class="flex-1">
      <label class="block text-sm font-medium mb-2">
        {{ t('galleryArtists.search.label') || 'Codice Galleria' }}
      </label>
      <input 
        type="text" 
        [(ngModel)]="galleryCode"
        (keyup.enter)="searchArtists()"
        placeholder="{{ t('galleryArtists.search.placeholder') || 'Inserisci il codice della galleria' }}"
        class="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
    <button 
      wunButton 
      primary
      (click)="searchArtists()"
      class="px-6 py-2">
      {{ t('galleryArtists.search.button') || 'Cerca' }}
    </button>
  </div>

  <!-- Tabella artisti -->
  <div class="flex-1 overflow-auto bg-white rounded-lg shadow">
    @if (artists.isLoading()) {
      <div class="flex items-center justify-center h-full">
        <p class="text-gray-500">{{ t('common.loading') || 'Caricamento...' }}</p>
      </div>
    } @else if (artists.error()) {
      <div class="flex items-center justify-center h-full">
        <p class="text-red-500">{{ t('common.error') || 'Errore nel caricamento dei dati' }}</p>
      </div>
    } @else if (artists.value()?.data && artists.value()!.data.length > 0) {
      <table class="w-full">
        <thead class="sticky top-0 bg-gray-100 border-b">
          <tr>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('galleryArtists.table.name') || 'Nome' }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('galleryArtists.table.email') || 'Email' }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('galleryArtists.table.city') || 'Città' }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('galleryArtists.table.phone') || 'Telefono' }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('galleryArtists.table.status') || 'Stato' }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('galleryArtists.table.registrationDate') || 'Data registrazione' }}</th>
          </tr>
        </thead>
        <tbody>
          @for (artist of artists.value()!.data; track artist.id) {
            <tr class="border-b hover:bg-gray-50 transition-colors" [class.bg-white]="$even" [class.bg-gray-50]="$odd">
              <td class="px-6 py-4">
                <div class="font-medium text-gray-900">{{ artist.firstName }} {{ artist.lastName }}</div>
                @if (artist.businessName) {
                  <div class="text-sm text-gray-500">{{ artist.businessName }}</div>
                }
              </td>
              <td class="px-6 py-4 text-gray-700">{{ artist.email }}</td>
              <td class="px-6 py-4 text-gray-700">{{ artist.city }}, {{ artist.country }}</td>
              <td class="px-6 py-4 text-gray-700">{{ artist.phone || 'N/D' }}</td>
              <td class="px-6 py-4">
                <span 
                  class="px-3 py-1 rounded-full text-xs font-semibold"
                  [class.bg-green-100]="artist.status === 'ACTIVE'"
                  [class.text-green-800]="artist.status === 'ACTIVE'"
                  [class.bg-yellow-100]="artist.status === 'PENDING'"
                  [class.text-yellow-800]="artist.status === 'PENDING'"
                  [class.bg-red-100]="artist.status === 'DISABLED'"
                  [class.text-red-800]="artist.status === 'DISABLED'">
                  {{ artist.status }}
                </span>
              </td>
              <td class="px-6 py-4 text-gray-700">{{ artist.createdAt | date: 'dd/MM/yyyy' }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="flex items-center justify-center h-full">
        <p class="text-gray-500">
          {{ t('galleryArtists.table.noResults') || 'Nessun artista trovato' }}
          @if (galleryCode()) {
            {{ t('galleryArtists.table.forCode') || 'per il codice' }} "{{ galleryCode() }}"
          }
        </p>
      </div>
    }
  </div>

  <!-- Paginazione -->
  @if (artists.value()?.data && artists.value()!.data.length > 0) {
    <div class="flex justify-between items-center px-4">
      <div class="text-sm text-gray-600">
        {{ t('galleryArtists.pagination.showing') || 'Mostrando' }} 
        {{ (page() - 1) * pageSize + 1 }} - 
        {{ Math.min(page() * pageSize, artists.value()!.totalCount) }} 
        {{ t('galleryArtists.pagination.of') || 'di' }} 
        {{ artists.value()!.totalCount }} 
        {{ t('galleryArtists.pagination.artists') || 'artisti' }}
      </div>
      <div class="flex gap-2">
        <button 
          wunButton
          (click)="previousPage()"
          [disabled]="!artists.value()?.hasPrevious">
          {{ t('galleryArtists.pagination.previous') || 'Precedente' }}
        </button>
        <span class="px-4 py-2 bg-gray-100 rounded">{{ page() }}</span>
        <button 
          wunButton
          primary
          (click)="nextPage()"
          [disabled]="!artists.value()?.hasNext">
          {{ t('galleryArtists.pagination.next') || 'Successivo' }}
        </button>
      </div>
    </div>
  }
</div>
